export const aboutCompanyData = {
  introImages: [
    'assets/images/company/f75d9edefd44422a368ef6d8a685376e91092fc1.jpg',
    'assets/images/company/f75d9edefd44422a368ef6d8a685376e91092fc1.jpg',
    'assets/images/company/f75d9edefd44422a368ef6d8a685376e91092fc1.jpg',
  ],

  features: [
    { title: '25 лет', desc: 'на рынке недвижимости' },
    { title: '4,5 млн. м²', desc: 'реализованной недвижимости' },
    { title: '1500+', desc: 'партнеров среди застройщиков и банков' },
    { title: '400+', desc: 'сотрудников уже работают в NDV' },
  ],

  companySystems: [
    {
      title: 'NDV-недвижимость',
      img: 'assets/images/company/image1.png',
      text: 'AI-платформа для поиска и управления объектами недвижимости в любой точке мира',
    },
    {
      title: 'NDV-ипотека',
      img: 'assets/images/company/image2.png',
      text: 'Сервис, предоставляющий доступ к различным ипотечным продуктам и кредитным решениям',
    },
    {
      title: 'NDV-страхование',
      img: 'assets/images/company/image3.png',
      text: 'Сервис по подбору услуг по страхованию недвижимости, страхованию жизни',
    },
    {
      title: 'NDV-оценка',
      img: 'assets/images/company/image4.png',
      text: 'AI-платформа для оценки рыночной стоимости объектов недвижимости',
    },
  ],

  partners: Array.from({ length: 8 }, (_, i) => ({
    img: `assets/images/company/partner${i + 1}.png`,
    img2x: `assets/images/company/partner${i + 1}@2x.png`,
    alt: `Partner ${i + 1}`,
  })),

  achievements: [
    {
      img: 'assets/images/company/award1.png',
      img2x: 'assets/images/company/award1@2x.png',
      title: 'Марка №1 в России',
      text: 'Победитель премии народного доверия потребителей',
    },
    {
      img: 'assets/images/company/award2.png',
      img2x: 'assets/images/company/award2@2x.png',
      title: 'Время инноваций',
      text: 'Победитель премии за внедрение, разработку и развитие инноваций в недвижимости',
    },
    {
      img: 'assets/images/company/award3.png',
      img2x: 'assets/images/company/award3@2x.png',
      title: 'Компания года',
      text: 'Победитель в номинации «Риэлторские услуги»',
    },
    {
      img: 'assets/images/company/award4.png',
      img2x: 'assets/images/company/award4@2x.png',
      title: 'Лучшие за 10 лет',
      text: 'Победитель премии в номинации “Лучшая концепция благоустройства и инфраструктуры”',
    },
    {
      img: 'assets/images/company/award5.png',
      img2x: 'assets/images/company/award5@2x.png',
      title: 'URBAN AWARDS',
      text: 'Победитель премии в специальной номинации “Лучшее агентство"',
    },
  ],
};
